import { COUNTRIES } from './countries';

export function findCountryByCode(code: string) {
    if (!code) {
        return '-';
    }
    const country = COUNTRIES[code];
    return country || '-';
}

export const haveLocalOrForeignContactNumber = (value: string) => {
    if (value === 'Loc') {
        return 'Local';
    } else if (value === 'FR') {
        return 'Foreign';
    } else if (value === 'LF') {
        return 'Local and Foreign';
    } else {
        return '-';
    }
};

export const isDashHide = (value: string) => {
    if (value === '-') {
        return true;
    } else {
        return false;
    }
}
interface Newspaper {
    id: number;
    nameOfNewspaper: string;
    genreDescription: string;
    permitNo: string;
    view: Boolean;
    print: Boolean;
}

export const calculatePrice = (row: Newspaper) => {
    let total = 0;

    if (row.print) {
        total += 2.0; // Add $2 if print is true
    }
    if (row.view) {
        total += 1.0; // Add $1 if view is true
    }

    return total;
};
